export default "__VITE_ASSET__6LThmvMz__"